/* eslint-disable */
import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { veTokenAbi } from "@/domains/abis"

import { simulatedTransaction } from "../simulated-transaction"

type IncreaseLockAmountProps = {
  account: Address
  chainId: number
  config: Config
  vestedAddress: Address
  tokenId: number
  amount: bigint
}

export const increaseLockAmount = async ({
  account,
  chainId,
  config,
  vestedAddress,
  tokenId,
  amount,
}: IncreaseLockAmountProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: veTokenAbi as unknown as Abi,
        account,
        address: vestedAddress,
        args: [tokenId, amount],
        chainId,
        functionName: "increase_amount",
      },
    })
    return result
  } catch (error: any) {
    console.error("increaseLockAmount", error)
    return { success: false, error: error.message, code: error.code }
  }
}

/*
const increaseLockAmount = async ({ web3, amount, tokenId, account, gasPrice, vestedAddress }) => {
  try {
    const options = { from: account }
    if (gasPrice) {
      options["gasPrice"] = gasPrice
    }
    const veTokenContract = new web3.eth.Contract(veTokenAbi, vestedAddress)
    const tx = await veTokenContract.methods.increase_amount(tokenId, amount).send(options)
    return { tx, success: true }
  } catch (error: any) {
    console.error("increaseLockAmount", error)
    // @ts-ignore
    return { tx: null, success: false, error: error.message, code: error.code }
  }
}
*/
